import { API_URL } from "constants";
import { apiRequest } from "./apiRequest";

export const getUrl = (eventId) => `${API_URL}/api/v2/appointments/schedule?id=${eventId}`;

export const scheduling = async (eventId, scheduleInfo) => {
    const url = getUrl(eventId);
    const body = {...scheduleInfo};
    return await apiRequest(url, "post", JSON.stringify(body));
};
